import React, { useEffect } from 'react';
import styles from './ResourceLayout.module.scss'
import { fetchJson } from '../../helpers/fetch.js';
import queryClient from '../../../query_client.js';
import {
  common_user_organisation_tree_options_path
} from '~/routes';

function ResourceLayout({ left, right, center, viewMode, permissions, children, personsFilter }) {
  useEffect(() => {
    if (!permissions.create && !personsFilter) return;
    queryClient.prefetchQuery({
      queryKey: ['commonUserOrganisationTreeOptions'],
      queryFn: () => fetchJson(common_user_organisation_tree_options_path()),
      staleTime: 5 * 60 * 1000,
    });
  }, [permissions.create, queryClient]);

  return (
    <>
      <div className={`no-border thin-scrollbar ${viewMode ? styles['view-mode'] : ''}`} style={viewMode ? {overflow: 'auto'} : {padding: 20}}>
        {!viewMode && <div className={styles['toolbar']}>
          <div className={styles['toolbar-left']}>
            {left}
          </div>
          <div className={styles['toolbar-center']}>
            {center}
          </div>
          <div className={styles['toolbar-right']}>
            {right}
          </div>
        </div>}
        {children}
      </div>
    </>
  );
}

export default ResourceLayout;